export default "__VITE_ASSET__CDAbpa9u__"